import { CREDIT_CARD_TYPES } from '../types/CreditCard'

const isDisplayInHandDate = (
    inHandDateString,
    orderDateString,
    eventDateString,
    ticketType,
    isLocalDelivery,
    isLocalPickup
) => {
    if (!Date.parse(inHandDateString)) {
        return false
    }
    if (!Date.parse(orderDateString)) {
        return false
    }
    if (!Date.parse(eventDateString)) {
        return false
    }

    if (isLocalDelivery) {
        return false
    }
    if (isLocalPickup) {
        return false
    }

    const localInHandDateMidnightTimestamp = new Date(inHandDateString).setHours(0, 0, 0, 0)
    const localOrderDateMidnightTimestamp = new Date(orderDateString).setHours(0, 0, 0, 0)
    const localEventDateMidnightTimestamp = new Date(eventDateString).setHours(0, 0, 0, 0)

    if (ticketType === 'instant') {
        return false
    }
    if (localInHandDateMidnightTimestamp <= localOrderDateMidnightTimestamp) {
        return false
    }
    if (localEventDateMidnightTimestamp < localInHandDateMidnightTimestamp) {
        return false
    }

    return true
}

const mapHostedFieldsCreditCardType = hostedFieldsCardType => {
    if (!hostedFieldsCardType) { return CREDIT_CARD_TYPES.UNKNOWN }

    switch (hostedFieldsCardType) {
    case 'american-express': return CREDIT_CARD_TYPES.AMEX
    case 'visa': return CREDIT_CARD_TYPES.VISA
    case 'master-card': return CREDIT_CARD_TYPES.MASTERCARD
    case 'discover': return CREDIT_CARD_TYPES.DISCOVER
    default: return CREDIT_CARD_TYPES.UNKNOWN
    }
}

export {
    isDisplayInHandDate,
    mapHostedFieldsCreditCardType
}
